
var Mutation_possibleTypes = ['Mutation']
module.exports.isMutation = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isMutation"')
  return Mutation_possibleTypes.includes(obj.__typename)
}



var Query_possibleTypes = ['Query']
module.exports.isQuery = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isQuery"')
  return Query_possibleTypes.includes(obj.__typename)
}



var v1AnalyzeTextQueryOutput_possibleTypes = ['v1AnalyzeTextQueryOutput']
module.exports.isv1AnalyzeTextQueryOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1AnalyzeTextQueryOutput"')
  return v1AnalyzeTextQueryOutput_possibleTypes.includes(obj.__typename)
}



var v1AutoCompleteUsersCompletionsApi_possibleTypes = ['v1AutoCompleteUsersCompletionsApi']
module.exports.isv1AutoCompleteUsersCompletionsApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1AutoCompleteUsersCompletionsApi"')
  return v1AutoCompleteUsersCompletionsApi_possibleTypes.includes(obj.__typename)
}



var v1AutoCompleteUsersOutput_possibleTypes = ['v1AutoCompleteUsersOutput']
module.exports.isv1AutoCompleteUsersOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1AutoCompleteUsersOutput"')
  return v1AutoCompleteUsersOutput_possibleTypes.includes(obj.__typename)
}



var v1CompanyEnrichment_possibleTypes = ['v1CompanyEnrichment']
module.exports.isv1CompanyEnrichment = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1CompanyEnrichment"')
  return v1CompanyEnrichment_possibleTypes.includes(obj.__typename)
}



var v1CompanyEntityApi_possibleTypes = ['v1CompanyEntityApi']
module.exports.isv1CompanyEntityApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1CompanyEntityApi"')
  return v1CompanyEntityApi_possibleTypes.includes(obj.__typename)
}



var v1CompanyV2_possibleTypes = ['v1CompanyV2']
module.exports.isv1CompanyV2 = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1CompanyV2"')
  return v1CompanyV2_possibleTypes.includes(obj.__typename)
}



var v1DeleteEmbeddingsOutput_possibleTypes = ['v1DeleteEmbeddingsOutput']
module.exports.isv1DeleteEmbeddingsOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1DeleteEmbeddingsOutput"')
  return v1DeleteEmbeddingsOutput_possibleTypes.includes(obj.__typename)
}



var v1EmbeddingOutput_possibleTypes = ['v1EmbeddingOutput']
module.exports.isv1EmbeddingOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1EmbeddingOutput"')
  return v1EmbeddingOutput_possibleTypes.includes(obj.__typename)
}



var v1EmbeddingUserOutput_possibleTypes = ['v1EmbeddingUserOutput']
module.exports.isv1EmbeddingUserOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1EmbeddingUserOutput"')
  return v1EmbeddingUserOutput_possibleTypes.includes(obj.__typename)
}



var v1EntityAggregation_possibleTypes = ['v1EntityAggregation']
module.exports.isv1EntityAggregation = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1EntityAggregation"')
  return v1EntityAggregation_possibleTypes.includes(obj.__typename)
}



var v1EntityAggregationBucket_possibleTypes = ['v1EntityAggregationBucket']
module.exports.isv1EntityAggregationBucket = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1EntityAggregationBucket"')
  return v1EntityAggregationBucket_possibleTypes.includes(obj.__typename)
}



var v1ExperienceGraphPrediction_possibleTypes = ['v1ExperienceGraphPrediction']
module.exports.isv1ExperienceGraphPrediction = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ExperienceGraphPrediction"')
  return v1ExperienceGraphPrediction_possibleTypes.includes(obj.__typename)
}



var v1ExplainTargeterQueryOutput_possibleTypes = ['v1ExplainTargeterQueryOutput']
module.exports.isv1ExplainTargeterQueryOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ExplainTargeterQueryOutput"')
  return v1ExplainTargeterQueryOutput_possibleTypes.includes(obj.__typename)
}



var v1FulltextSearchUsersOutput_possibleTypes = ['v1FulltextSearchUsersOutput']
module.exports.isv1FulltextSearchUsersOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1FulltextSearchUsersOutput"')
  return v1FulltextSearchUsersOutput_possibleTypes.includes(obj.__typename)
}



var v1FulltextSearchUsersUsersApi_possibleTypes = ['v1FulltextSearchUsersUsersApi']
module.exports.isv1FulltextSearchUsersUsersApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1FulltextSearchUsersUsersApi"')
  return v1FulltextSearchUsersUsersApi_possibleTypes.includes(obj.__typename)
}



var v1IndustriesExperience_possibleTypes = ['v1IndustriesExperience']
module.exports.isv1IndustriesExperience = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1IndustriesExperience"')
  return v1IndustriesExperience_possibleTypes.includes(obj.__typename)
}



var v1IndustryEntityApi_possibleTypes = ['v1IndustryEntityApi']
module.exports.isv1IndustryEntityApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1IndustryEntityApi"')
  return v1IndustryEntityApi_possibleTypes.includes(obj.__typename)
}



var v1IndustryExperienceReference_possibleTypes = ['v1IndustryExperienceReference']
module.exports.isv1IndustryExperienceReference = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1IndustryExperienceReference"')
  return v1IndustryExperienceReference_possibleTypes.includes(obj.__typename)
}



var v1JobExperiences_possibleTypes = ['v1JobExperiences']
module.exports.isv1JobExperiences = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1JobExperiences"')
  return v1JobExperiences_possibleTypes.includes(obj.__typename)
}



var v1ListCitiesOutput_possibleTypes = ['v1ListCitiesOutput']
module.exports.isv1ListCitiesOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ListCitiesOutput"')
  return v1ListCitiesOutput_possibleTypes.includes(obj.__typename)
}



var v1ListCompaniesOutput_possibleTypes = ['v1ListCompaniesOutput']
module.exports.isv1ListCompaniesOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ListCompaniesOutput"')
  return v1ListCompaniesOutput_possibleTypes.includes(obj.__typename)
}



var v1ListEmbeddingsOutput_possibleTypes = ['v1ListEmbeddingsOutput']
module.exports.isv1ListEmbeddingsOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ListEmbeddingsOutput"')
  return v1ListEmbeddingsOutput_possibleTypes.includes(obj.__typename)
}



var v1ListIndustriesOutput_possibleTypes = ['v1ListIndustriesOutput']
module.exports.isv1ListIndustriesOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ListIndustriesOutput"')
  return v1ListIndustriesOutput_possibleTypes.includes(obj.__typename)
}



var v1ListProvincesOutput_possibleTypes = ['v1ListProvincesOutput']
module.exports.isv1ListProvincesOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ListProvincesOutput"')
  return v1ListProvincesOutput_possibleTypes.includes(obj.__typename)
}



var v1ListRoleCategoriesOutput_possibleTypes = ['v1ListRoleCategoriesOutput']
module.exports.isv1ListRoleCategoriesOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ListRoleCategoriesOutput"')
  return v1ListRoleCategoriesOutput_possibleTypes.includes(obj.__typename)
}



var v1ListSkillsOutput_possibleTypes = ['v1ListSkillsOutput']
module.exports.isv1ListSkillsOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ListSkillsOutput"')
  return v1ListSkillsOutput_possibleTypes.includes(obj.__typename)
}



var v1ListUsersOutput_possibleTypes = ['v1ListUsersOutput']
module.exports.isv1ListUsersOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ListUsersOutput"')
  return v1ListUsersOutput_possibleTypes.includes(obj.__typename)
}



var v1MissionApplicationAvailability_possibleTypes = ['v1MissionApplicationAvailability']
module.exports.isv1MissionApplicationAvailability = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionApplicationAvailability"')
  return v1MissionApplicationAvailability_possibleTypes.includes(obj.__typename)
}



var v1MissionApplicationChanges_possibleTypes = ['v1MissionApplicationChanges']
module.exports.isv1MissionApplicationChanges = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionApplicationChanges"')
  return v1MissionApplicationChanges_possibleTypes.includes(obj.__typename)
}



var v1MissionApplicationEntityApi_possibleTypes = ['v1MissionApplicationEntityApi']
module.exports.isv1MissionApplicationEntityApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionApplicationEntityApi"')
  return v1MissionApplicationEntityApi_possibleTypes.includes(obj.__typename)
}



var v1MissionApplicationHourlyRateRange_possibleTypes = ['v1MissionApplicationHourlyRateRange']
module.exports.isv1MissionApplicationHourlyRateRange = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionApplicationHourlyRateRange"')
  return v1MissionApplicationHourlyRateRange_possibleTypes.includes(obj.__typename)
}



var v1MissionApplicationProposedRates_possibleTypes = ['v1MissionApplicationProposedRates']
module.exports.isv1MissionApplicationProposedRates = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionApplicationProposedRates"')
  return v1MissionApplicationProposedRates_possibleTypes.includes(obj.__typename)
}



var v1MissionApplicationReviewStatus_possibleTypes = ['v1MissionApplicationReviewStatus']
module.exports.isv1MissionApplicationReviewStatus = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionApplicationReviewStatus"')
  return v1MissionApplicationReviewStatus_possibleTypes.includes(obj.__typename)
}



var v1MissionApplicationRoleHistory_possibleTypes = ['v1MissionApplicationRoleHistory']
module.exports.isv1MissionApplicationRoleHistory = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionApplicationRoleHistory"')
  return v1MissionApplicationRoleHistory_possibleTypes.includes(obj.__typename)
}



var v1MissionAttachedLink_possibleTypes = ['v1MissionAttachedLink']
module.exports.isv1MissionAttachedLink = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionAttachedLink"')
  return v1MissionAttachedLink_possibleTypes.includes(obj.__typename)
}



var v1MissionEntityApi_possibleTypes = ['v1MissionEntityApi']
module.exports.isv1MissionEntityApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionEntityApi"')
  return v1MissionEntityApi_possibleTypes.includes(obj.__typename)
}



var v1MissionManager_possibleTypes = ['v1MissionManager']
module.exports.isv1MissionManager = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionManager"')
  return v1MissionManager_possibleTypes.includes(obj.__typename)
}



var v1MissionRoleEntityApi_possibleTypes = ['v1MissionRoleEntityApi']
module.exports.isv1MissionRoleEntityApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionRoleEntityApi"')
  return v1MissionRoleEntityApi_possibleTypes.includes(obj.__typename)
}



var v1MissionRoleSkill_possibleTypes = ['v1MissionRoleSkill']
module.exports.isv1MissionRoleSkill = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionRoleSkill"')
  return v1MissionRoleSkill_possibleTypes.includes(obj.__typename)
}



var v1MissionRoleVisibility_possibleTypes = ['v1MissionRoleVisibility']
module.exports.isv1MissionRoleVisibility = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionRoleVisibility"')
  return v1MissionRoleVisibility_possibleTypes.includes(obj.__typename)
}



var v1MissionRoleWorkingHours_possibleTypes = ['v1MissionRoleWorkingHours']
module.exports.isv1MissionRoleWorkingHours = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionRoleWorkingHours"')
  return v1MissionRoleWorkingHours_possibleTypes.includes(obj.__typename)
}



var v1MissionRoleWorkingHoursDaily_possibleTypes = ['v1MissionRoleWorkingHoursDaily']
module.exports.isv1MissionRoleWorkingHoursDaily = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1MissionRoleWorkingHoursDaily"')
  return v1MissionRoleWorkingHoursDaily_possibleTypes.includes(obj.__typename)
}



var v1NotificationEntryGQL_possibleTypes = ['v1NotificationEntryGQL']
module.exports.isv1NotificationEntryGQL = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1NotificationEntryGQL"')
  return v1NotificationEntryGQL_possibleTypes.includes(obj.__typename)
}



var v1NotificationMetadataGQL_possibleTypes = ['v1NotificationMetadataGQL']
module.exports.isv1NotificationMetadataGQL = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1NotificationMetadataGQL"')
  return v1NotificationMetadataGQL_possibleTypes.includes(obj.__typename)
}



var v1NotificationPreferences_possibleTypes = ['v1NotificationPreferences']
module.exports.isv1NotificationPreferences = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1NotificationPreferences"')
  return v1NotificationPreferences_possibleTypes.includes(obj.__typename)
}



var v1NotificationsIndex_possibleTypes = ['v1NotificationsIndex']
module.exports.isv1NotificationsIndex = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1NotificationsIndex"')
  return v1NotificationsIndex_possibleTypes.includes(obj.__typename)
}



var v1PauseNotifications_possibleTypes = ['v1PauseNotifications']
module.exports.isv1PauseNotifications = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1PauseNotifications"')
  return v1PauseNotifications_possibleTypes.includes(obj.__typename)
}



var v1ProjectExperiences_possibleTypes = ['v1ProjectExperiences']
module.exports.isv1ProjectExperiences = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ProjectExperiences"')
  return v1ProjectExperiences_possibleTypes.includes(obj.__typename)
}



var v1ProvinceEntityApi_possibleTypes = ['v1ProvinceEntityApi']
module.exports.isv1ProvinceEntityApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1ProvinceEntityApi"')
  return v1ProvinceEntityApi_possibleTypes.includes(obj.__typename)
}



var v1RoleCategoryEntityApi_possibleTypes = ['v1RoleCategoryEntityApi']
module.exports.isv1RoleCategoryEntityApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1RoleCategoryEntityApi"')
  return v1RoleCategoryEntityApi_possibleTypes.includes(obj.__typename)
}



var v1SearchMissionAggregation_possibleTypes = ['v1SearchMissionAggregation']
module.exports.isv1SearchMissionAggregation = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SearchMissionAggregation"')
  return v1SearchMissionAggregation_possibleTypes.includes(obj.__typename)
}



var v1SearchMissionApplicationsOutput_possibleTypes = ['v1SearchMissionApplicationsOutput']
module.exports.isv1SearchMissionApplicationsOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SearchMissionApplicationsOutput"')
  return v1SearchMissionApplicationsOutput_possibleTypes.includes(obj.__typename)
}



var v1SearchMissionsOutput_possibleTypes = ['v1SearchMissionsOutput']
module.exports.isv1SearchMissionsOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SearchMissionsOutput"')
  return v1SearchMissionsOutput_possibleTypes.includes(obj.__typename)
}



var v1SearchUsersOutput_possibleTypes = ['v1SearchUsersOutput']
module.exports.isv1SearchUsersOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SearchUsersOutput"')
  return v1SearchUsersOutput_possibleTypes.includes(obj.__typename)
}



var v1SemanticSearch_possibleTypes = ['v1SemanticSearch']
module.exports.isv1SemanticSearch = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SemanticSearch"')
  return v1SemanticSearch_possibleTypes.includes(obj.__typename)
}



var v1SimilarBuilderEntry_possibleTypes = ['v1SimilarBuilderEntry']
module.exports.isv1SimilarBuilderEntry = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SimilarBuilderEntry"')
  return v1SimilarBuilderEntry_possibleTypes.includes(obj.__typename)
}



var v1SkillEntityApi_possibleTypes = ['v1SkillEntityApi']
module.exports.isv1SkillEntityApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SkillEntityApi"')
  return v1SkillEntityApi_possibleTypes.includes(obj.__typename)
}



var v1StructuredCompanyEnrichment_possibleTypes = ['v1StructuredCompanyEnrichment']
module.exports.isv1StructuredCompanyEnrichment = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1StructuredCompanyEnrichment"')
  return v1StructuredCompanyEnrichment_possibleTypes.includes(obj.__typename)
}



var v1SuggestUsersOutput_possibleTypes = ['v1SuggestUsersOutput']
module.exports.isv1SuggestUsersOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SuggestUsersOutput"')
  return v1SuggestUsersOutput_possibleTypes.includes(obj.__typename)
}



var v1SuggestUsersSuggestionApi_possibleTypes = ['v1SuggestUsersSuggestionApi']
module.exports.isv1SuggestUsersSuggestionApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SuggestUsersSuggestionApi"')
  return v1SuggestUsersSuggestionApi_possibleTypes.includes(obj.__typename)
}



var v1SuggestedJobExperiences_possibleTypes = ['v1SuggestedJobExperiences']
module.exports.isv1SuggestedJobExperiences = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SuggestedJobExperiences"')
  return v1SuggestedJobExperiences_possibleTypes.includes(obj.__typename)
}



var v1SuggestedProjectExperiences_possibleTypes = ['v1SuggestedProjectExperiences']
module.exports.isv1SuggestedProjectExperiences = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1SuggestedProjectExperiences"')
  return v1SuggestedProjectExperiences_possibleTypes.includes(obj.__typename)
}



var v1TimesheetSummaryEntry_possibleTypes = ['v1TimesheetSummaryEntry']
module.exports.isv1TimesheetSummaryEntry = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1TimesheetSummaryEntry"')
  return v1TimesheetSummaryEntry_possibleTypes.includes(obj.__typename)
}



var v1TranscriptSearch_possibleTypes = ['v1TranscriptSearch']
module.exports.isv1TranscriptSearch = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1TranscriptSearch"')
  return v1TranscriptSearch_possibleTypes.includes(obj.__typename)
}



var v1UpdateCompaniesOutput_possibleTypes = ['v1UpdateCompaniesOutput']
module.exports.isv1UpdateCompaniesOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UpdateCompaniesOutput"')
  return v1UpdateCompaniesOutput_possibleTypes.includes(obj.__typename)
}



var v1UpdateEmbeddingsOutput_possibleTypes = ['v1UpdateEmbeddingsOutput']
module.exports.isv1UpdateEmbeddingsOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UpdateEmbeddingsOutput"')
  return v1UpdateEmbeddingsOutput_possibleTypes.includes(obj.__typename)
}



var v1UpdateUserNotificationsOutput_possibleTypes = ['v1UpdateUserNotificationsOutput']
module.exports.isv1UpdateUserNotificationsOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UpdateUserNotificationsOutput"')
  return v1UpdateUserNotificationsOutput_possibleTypes.includes(obj.__typename)
}



var v1UpdateUserOutput_possibleTypes = ['v1UpdateUserOutput']
module.exports.isv1UpdateUserOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UpdateUserOutput"')
  return v1UpdateUserOutput_possibleTypes.includes(obj.__typename)
}



var v1UpdateUsersOutput_possibleTypes = ['v1UpdateUsersOutput']
module.exports.isv1UpdateUsersOutput = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UpdateUsersOutput"')
  return v1UpdateUsersOutput_possibleTypes.includes(obj.__typename)
}



var v1UserAdminNoteScore_possibleTypes = ['v1UserAdminNoteScore']
module.exports.isv1UserAdminNoteScore = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserAdminNoteScore"')
  return v1UserAdminNoteScore_possibleTypes.includes(obj.__typename)
}



var v1UserAdminNotes_possibleTypes = ['v1UserAdminNotes']
module.exports.isv1UserAdminNotes = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserAdminNotes"')
  return v1UserAdminNotes_possibleTypes.includes(obj.__typename)
}



var v1UserEntityApi_possibleTypes = ['v1UserEntityApi']
module.exports.isv1UserEntityApi = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserEntityApi"')
  return v1UserEntityApi_possibleTypes.includes(obj.__typename)
}



var v1UserHourlyRate_possibleTypes = ['v1UserHourlyRate']
module.exports.isv1UserHourlyRate = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserHourlyRate"')
  return v1UserHourlyRate_possibleTypes.includes(obj.__typename)
}



var v1UserLinkedIn_possibleTypes = ['v1UserLinkedIn']
module.exports.isv1UserLinkedIn = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserLinkedIn"')
  return v1UserLinkedIn_possibleTypes.includes(obj.__typename)
}



var v1UserLocation_possibleTypes = ['v1UserLocation']
module.exports.isv1UserLocation = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserLocation"')
  return v1UserLocation_possibleTypes.includes(obj.__typename)
}



var v1UserTalentProfile_possibleTypes = ['v1UserTalentProfile']
module.exports.isv1UserTalentProfile = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserTalentProfile"')
  return v1UserTalentProfile_possibleTypes.includes(obj.__typename)
}



var v1UserTalentProfileSkillEntry_possibleTypes = ['v1UserTalentProfileSkillEntry']
module.exports.isv1UserTalentProfileSkillEntry = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserTalentProfileSkillEntry"')
  return v1UserTalentProfileSkillEntry_possibleTypes.includes(obj.__typename)
}



var v1UserTalentProfileSkills_possibleTypes = ['v1UserTalentProfileSkills']
module.exports.isv1UserTalentProfileSkills = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserTalentProfileSkills"')
  return v1UserTalentProfileSkills_possibleTypes.includes(obj.__typename)
}



var v1UserTalentSkills_possibleTypes = ['v1UserTalentSkills']
module.exports.isv1UserTalentSkills = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserTalentSkills"')
  return v1UserTalentSkills_possibleTypes.includes(obj.__typename)
}



var v1UserTalentSpecializations_possibleTypes = ['v1UserTalentSpecializations']
module.exports.isv1UserTalentSpecializations = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserTalentSpecializations"')
  return v1UserTalentSpecializations_possibleTypes.includes(obj.__typename)
}



var v1UserWorkingHours_possibleTypes = ['v1UserWorkingHours']
module.exports.isv1UserWorkingHours = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserWorkingHours"')
  return v1UserWorkingHours_possibleTypes.includes(obj.__typename)
}



var v1UserWorkingHoursSlot_possibleTypes = ['v1UserWorkingHoursSlot']
module.exports.isv1UserWorkingHoursSlot = function(obj) {
  if (!obj || !obj.__typename) throw new Error('__typename is missing in "isv1UserWorkingHoursSlot"')
  return v1UserWorkingHoursSlot_possibleTypes.includes(obj.__typename)
}
